module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Pro-8adee7e43b1cb010a9dba6cf2309a56b.svg";